/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_TitleInputs */

const en_pc_tut_organize_title = /** @type {(inputs: Pc_Tut_Organize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate, delete, insert and move pages`)
};

const zh_pc_tut_organize_title = /** @type {(inputs: Pc_Tut_Organize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旋转、删除、插入和移动页面`)
};

/**
* | output |
* | --- |
* | "Rotate, delete, insert and move pages" |
*
* @param {Pc_Tut_Organize_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_title = /** @type {((inputs?: Pc_Tut_Organize_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_title(inputs)
	return zh_pc_tut_organize_title(inputs)
});
export { pc_tut_organize_title as "pc.tut.organize.title" }